// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1bFQK","Logo":"Header_Logo__XAzMU"};